export const removeUUIDFromFilename = (filename: string) => {
  // Regular expression to match a UUID (8-4-4-4-12 format)
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}-/;

  // Replace the UUID pattern with an empty string
  return filename.replace(uuidRegex, '');
};
